import React from 'react';
import Waypoint from 'react-waypoint';

import BaseSectionBookend from './BaseSectionBookend';
import Navigation from '../Navigation';
import HeroIllustration from './HeroIllustration';
import InstallButton from '../InstallButton';

class Hero extends BaseSectionBookend {
	render() {
		return (
			<div className="section section--centered section--full-height bg--light-blue">
				<Navigation />

				<div className={this.getClassNames()}>
					<h1>Tabby Cat</h1>
					<p>A new friend in every tab.</p>
					<InstallButton classNames={'install-button install-button--light-blue'} hoverOnButton={this.hoverOnButton} hoverOffButton={this.hoverOffButton} />
					<Waypoint onEnter={this.wayPointEntered} />
				</div>

				<HeroIllustration buttonHover={this.state.buttonHover} />
			</div>
		);
	}
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Site/Home/SectionFirst.js